export const GET_BANKS = "GET_BANKS";
export const GET_BANKS_START = "GET_BANKS_START";
export const GET_BANKS_FAILED = "GET_BANKS_FAILED";
